export const decidePillar = ({ pillar, design, }) => {
    // We override the pillar to be opinion on Comment news pieces
    if (design === 'Comment' && pillar === 'news')
        return 'opinion';
    return pillar;
};
